import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/phone-outline.svg")